import { createSelector } from "reselect";
import * as R from "ramda";

export const deductions = ({ deductions }) => deductions.items;

const deferredApplication = f => (f1, f2) => (a, b) => f(f1(a), f2(b));

const dadd = deferredApplication(R.add);

const past90Days = (deduction) => {
  const now = new Date();
  const date = new Date(deduction.date);
  const diff = (now - date) / (1000 * 60 * 60 * 24);
  return diff <= 90;
};

export const totalDeductionAmount = createSelector(
  deductions,
  R.pipe(
    R.filter(past90Days),
    R.uniqBy(R.prop('deductionId')),
    R.reduce(
      dadd(R.identity, R.prop("deductionAmt")),
      0
    )
  ),
)
